import * as service from '../../pages/Administration/OrganizationDetails.service'
import * as services from './addcertificates.service'

export default {
  props: ["Certificateparams"],
  data() {
    return {
      defaultExpiryDropDown: 'Years',

      Certificationcolumns: ['Name', 'Description', 'Actions'],
      optionstable: {

        headings: {
          Name: 'Name',
          Description: 'Description',
          edit: 'Edit',
          delete: 'Delete',
          Actions: ''

        },
        sortIcon: {
          base: 'glyphicon',
          up: 'glyphicon-chevron-up',
          down: 'glyphicon-chevron-down'
        },
        sortable: ['Name', 'Description'],
        texts: {

          filterPlaceholder: 'Search...',
          limit: 'Records:',
          noResults: 'No matching records',

        },
        sortable: [],

      },
      isaddCertificateTopic: false,
      CertificationTypes: [],
      AddCertificateForm: {

        Name: '',
        Description: '',
        IsActive: true,
        IssuedBy: '',
        ExpiryPeriod: '',
        ExpiryPeriodStatus: 'd'
      },
      agencydropdown: [],
      IsCertificateTypeEdit: false,
      period: 'd',
      CertificateTypeEditID: 0,
      organizationDetails: {},
      locations: [],
      pools: [],
      DisciplinaryAction: [],
      locationName: '',
      poolName: '',
      selectedlocationId: '',
      selectedpoolId: '',
      editLocation: false,
      editPool: false,
      currentLocationName: '',
      currentPoolName: '',
      act: false,
      poolpromptVisible: false,
      locationpromptVisible: false,
      positionpromptVisible: false,
      IsDiscEdit: false,
      selectedagency: '',
      organizationName: '',
      locationFlag: false,
      orgEditorgEdit: false,
      tabName: 'first',
      position: '',
      positions: [],
      roles: [],
      editPosition: false,
      selectedpositionId: '',
      currentPositionName: '',
      roleModel: '',
      modalTitle: '',
      AgencyCertificateList: [],
      isNewCertificates: '',
      Certificatelist: [],
      Agencylist: [],
      isaddCertificate: false,
      isediting: false,
      agencyforedit: [],
      role: '',
      Certificate: {
        CertificateName: '',
        OrgCertificateNameId: '',
        ExpiryPeriod: '',
        ExpiryStatus: '',
        IsActive: '',
        OrgCertificateAgencyId: '',
        Id: '',
        CertificateAgency: '',
        OrganizationId: ''
      },
      idlist: [],
      CertificateTopicName: '',
      ExpiryStatusList: [{
        Status: 'Years',
        Value: 'Years'
      }, {
        Status: 'Months',
        Value: 'Months'
      }, {
        Status: 'Days',
        Value: 'Days'
      }],
      tree_class: 'fa-minus-circle',
      options: [{
        value: 'PDT',
        label: 'PDT'
      }, {
        value: 'MDT',
        label: 'MDT'
      }, {
        value: 'CDT',
        label: 'CDT'
      }, {
        value: 'EDT',
        label: 'EDT'
      }],
      Timezone: '',
      pdays: [],
      cdays: '',
      Timezoneselected: ''
    }
  },
  mounted() {

    var id = this.Certificateparams.organizationid
    this.pdays = [{
        value: 'd',
        label: 'Days'
      },
      {
        value: 'm',
        label: 'Months'
      },
      {
        value: 'y',
        label: 'Years'
      }
    ]
    this.organizationDetails = {
      organizationId: authDetails.OrganizationId,
      organizationName: authDetails.OrganizationName
    }
    this.role = JSON.parse(this.$localStorage.get('authentication')).role

    this.getAllAgencyCertificates()
    this.getAllActiveCertificateAgency()
  },

  methods: {
    checkNumber() {
      let context = this
      setTimeout(function () {
        context.AddCertificateForm.ExpiryPeriod = context.AddCertificateForm.ExpiryPeriod.replace(/[^0-9]/g, '')
      }, 10)

    },    
    getAllActiveCertificateAgency() {
      let context = this;
      //admin cert - get the agencies
      services.GetAllCertificateAgency(this.Certificateparams.organizationid).then(function (response) {

        //Is this restricted ? -- FG - After Cert - First Release Security
        if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) { 
          context.Agencylist = []  
          loader.stopLoader()
          return;
        }

          context.agencydropdown = deepcopy(response)
          context.Agencylist = response
          context.Agencylist.push({
            "Id": '0',
            "Name": "New"
          })
          context.selectedagency = context.Agencylist[0].Id
        },
        (error) => {
          loader.stopLoader()
          this.$notify({
            title: 'Error',
            message: error.responseJSON.Message,
            type: 'error'
          })
        })
    },
    getAllAgencyCertificates() {

      let context = this;
      //admin cert - get the "tree"
      services.GetCertificateAgencyTree(this.Certificateparams.organizationid).then(function (response) {
        
        //Is this restricted ? -- FG - After Cert - First Release Security
        if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) { 
          context.AgencyCertificateList = []  
          loader.stopLoader()
          return;
        }

        context.AgencyCertificateList = response
        services.AllCertificates(true, context.Certificateparams.organizationid).then(function (result) {
          result.map(function (el) {

            var flag = false
            for (var i = 0; i < context.AgencyCertificateList.length; i++) {
              if (el.Id == context.AgencyCertificateList[i].CertificateNameId) {
                flag = true
              }
            }
            if (flag == false) {
              context.AgencyCertificateList.push({
                CertificateNameId: el.Id,
                CertificateName: el.Name,
                IsActive: el.IsActive,
                IsAdminCustom: el.IsAdminCustom,
                IsDirectorCustom: el.IsDirectorCustom,
                showChild: false,
                isaddChild: false,
                iseditCertificateName: false,
                EditCertificatename: ''
              })
            }
          })
        }, (error) => {
          loader.stopLoader()
          this.$notify({
            title: 'Error',
            message: error.responseJSON.Message,
            type: 'error'
          })
        })
        context.AgencyCertificateList = response.map(function (el) {
          var o = Object.assign({}, el);
          o.showChild = false;
          o.isaddChild = false;
          o.iseditCertificateName = false;
          o.EditCertificatename = "";
          var isadmincustom = false;
          var isdefault = false;
          var isdirectorcustom = false;
          if (o.Agencies) {
            o.Agencies.filter(function (item) {
              if (item.IsDefault == true)
                isdefault = true
              if (item.IsAdminCustom == true)
                isadmincustom = true
              if (item.IsDirectorCustom == true)
                isdirectorcustom = true
            })
            o.IsAdminCustom = isadmincustom
            o.IsDefault = isdefault
            o.IsDirectorCustom = isdirectorcustom
          }
          return o;
        })

        context.selectedcertificates = context.CertificateList[0].Id
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },
    canceladdTopic() {
      this.isaddCertificateTopic = false
    },

    //FG - FOOF - After Cert - First Release (5) - Rewrote function below to use new functions in
    //  hydrowareCommon.js - look for "FG - FOOF - After Cert - First Release (5)" to find them
    deleteCertificate(item) {      
      let context = this
      var opts = {message: 'Are you sure you want to delete ' + item.CertificateAgencyName +'?'}
      context.$hydrowareCommonJS.displayConfirmDeletePopup(context, opts, context.callOnServiceToDelete.bind(null,item))
    },


    callOnServiceToDelete(item) {
      let context=this;
      loader.startLoader()
      var idlist = []
      idlist.push(item.CertificateId)
      var deleteobj = {"IdList": idlist}
       //admin cert - DELETE CERT AGENCY      
      services.DeleteCertificate(deleteobj, this.Certificateparams.organizationid).then(
          function (response) { //FG - FOOF - After Cert - First Release Security - added response as a parm

            //Is this restricted ? -- FG - After Cert - First Release Security
            if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) { 
              loader.stopLoader()
              return;
            }

              loader.stopLoader()
              context.getAllAgencyCertificates();
              context.$hydrowareCommonJS.notifyDeleteSuccess(context);
          }, 
          (error) => {
              loader.stopLoader()
              this.$hydrowareCommonJS.notifyError(this,{message: error.responseJSON.Message});
          }
      )
    },


    tryThisFunction(stuff) {
      var opts = {
        title: "STUFF: " + stuff,
        message: "The delete was BLA BLA BLA."
      }
      this.$hydrowareCommonJS.displayPopupNoDelete(this,opts)
    },


    deleteCertificateTopic(certificate) {
      let context = this
      var idList = []
      if (this.role == "Admin")
        certificate.Agencies.filter(function (item) {
          if (item.IsAdminCustom || item.IsDirectorCustom) {
            idList.push(item.CertificateId)
          }
        })
      if (this.role == "AquaticsDirector") {
        certificate.Agencies.filter(function (item) {
          if (item.IsDirectorCustom) {
            idList.push(item.CertificateId)
          }
        })
      }
      idList.join(',')
      var deleteobj = {
        "IdList": idList
      }
      services.DeleteCertificate(deleteobj, this.Certificateparams.organizationid).then(function () {
        loader.stopLoader()
        context.getAllAgencyCertificates();
        context.$notify({
          title: 'Deleted',
          message: 'Deleted Successfully',
          type: 'success'
        })
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
      
    },

    //------------------------------------------------------------------------------
    //FOOF - CERTIFICATE - ACTIVATE/DEACTIVATE
    //FG - FOOF - After Cert - First Release - FOUND DURING SECURITY REWRITE---
    //THE ORIGINAL CODE WANTED THE ACTIVATE/DEACTIVATE TO TAKE PLACE AS SOON AS THE
    //THE CHECK BOX WAS CLICKED BUT FUNCTION BELOW FAILED.  I (FG) THOUGHT THAT
    //UPDATING THE STATUS IN THIS MANNER WAS NOT CONSISTENT
    //WITH THE WAY THE OTHER EDITS WERE APPLIED SO RATHER THAN TRYING TO
    //FIX THIS CODE I SIMPLY MODIFIED THE CHECKBOX (managecertificates.vue see- "FOOF - ACTIVATE/DEACTIVATE") SO 
    //THE FUNCTION BELOW IS NOT CALLED AT ALL. 
    //THE STATUS UPDATE TAKES PLACE WHEN THE "SAVE" BUTTON IS CLICKED.
    DeactivateCertificate(item) {    
      //admin cert - ?? USED ?? DEACTIVATE - NO LONGER USED
      alert("CHANGE CERT AGENCY STATUS (ACTIVE/DEACTIVE")
      /*
      let context = this;
      var idlist = []
      idlist.push(item.CertificateId)
      idlist.join(',')
      var object = {
        ActiveStatus: item.IsActive,
        IdList: idlist
      }
      loader.startLoader()
      services.ChangeCertificateStatus(object, this.Certificateparams.organizationid).then(function (response) { //FG - FOOF - After Cert - First Release Security - added response as parm
        
        //Is this restricted ? -- FG - After Cert - First Release Security
            if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) { 
              loader.stopLoader()
              return;
            }
        
        loader.stopLoader()
        context.$notify({
          title: 'Success',
          message: 'Changed the status',
          type: 'success'
        })
      }, (error) => {
        loader.stopLoader()
        item.IsActive = !item.IsActive
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
      */
    },
    //FG - FOOF - FUNCTION ABOVE IS NO LONGER CALLED
    //-----------------------------------------------------------------------

    editCertificate(agency, certificateitem) {
      this.isediting = true
      certificateitem.isaddChild = true
      this.Certificate.OrgCertificateNameId = certificateitem.CertificateNameId;
      this.Certificate.ExpiryPeriod = agency.ExpiryPeriod
      this.Certificate.ExpiryStatus = agency.ExpiryStatus
      this.Certificate.IsActive = agency.IsActive
      this.Certificate.Id = agency.CertificateId
      this.selectedagency = agency.CertificateAgencyId;
    },
    updateCertificate(item) {
      //admin cert - UPDATE CERT AGENCY
     let context = this
      this.Certificate.OrgCertificateNameId = item.CertificateNameId
      this.Certificate.OrgCertificateAgencyId = this.selectedagency
      this.Certificate.OrganizationId = this.Certificateparams.organizationid
      if (this.Certificate.ExpiryPeriod == "" && this.Certificate.ExpiryStatus != "") {
        this.Certificate.ExpiryStatus == ""
      }
      loader.startLoader()

      services.UpdateCertificates(this.Certificate).then(function (response) {
        
        //Is this restricted ? -- FG - After Cert - First Release Security
        if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) { 
          loader.stopLoader()
          return;
        }

        context.getAllAgencyCertificates();
        loader.stopLoader()
        context.$notify({
          title: 'Updated',
          message: 'Updated Successfully',
          type: 'success'
        })
      }, (error) => {
        loader.stopLoader()
        context.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },
    changeMonth(per) {

      if (per == 'y') {
        this.cdays = this.AddCertificateForm.ExpiryPeriod * 365
      } else if (per == 'm') {
        this.cdays = this.AddCertificateForm.ExpiryPeriod * 30
      } else {
        this.cdays = per
      }

    },

    showactions() {
      this.IsDiscEdit = false
      this.DisciplineForm = {
        Name: '',
        Description: '',
        IsActive: true,
        IssuedBy: '',
        ExpiryPeriod: '',
        ExpiryPeriodStatus: 'd'
      }
      $('#AddEventsmodel').modal('show')
    },
    showcertificate() {
      let context = this
      this.modalTitle = 'Add Certificate Type'
      $('#AddCertificatemodel').modal('show')

      setTimeout(function () {
        context.$refs['AddCertificateForm'].resetFields()
      }, 10)
    },
    addCertificate(item) {
      //admin cert - ADD CERT AGENCY
      let context = this
      this.Certificate.OrgCertificateAgencyId = this.selectedagency
      this.Certificate.OrgCertificateNameId = item.CertificateNameId
      if (this.Certificate.ExpiryPeriod == "" && this.Certificate.ExpiryStatus != "") {
        this.Certificate.ExpiryStatus == ""
      }
      this.Certificate.OrganizationId = this.Certificateparams.organizationid
      services.AddCertificates(this.Certificate).then(function (response) {

        //Is this restricted ? -- FG - After Cert - First Release Security
        if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) { 
          loader.stopLoader()
          return;
        }

        loader.stopLoader()
        context.$notify({
          title: 'Success',
          message: 'Created Successfully',
          type: 'success'
        })
        context.getAllAgencyCertificates();
        context.getAllActiveCertificateAgency()

      }, (error) => {
        loader.stopLoader()
        context.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },

    /*FG - FOOF - After Cert - First Release (5) 
      I do not think the method below is used anymore.  It was left here by digiclarity
      I have changed the text that displays so it reads "(MSG 01) Are you sure you would like to"
      instead of "Are you sure you want to"... If while testing you see a dialog that says
      "(MSG 01) Are you sure you would like to..." then you know it is still being used.
    */
    del: function (data) { alert("DELETE 1")

      var ID = data.row.Id

      let context = this
      context.$confirm('(MSG 01) Are you sure you would like to delete?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {

        loader.startLoader()
        service.DeleteCertificationType(ID).then(function (response) {

          context.GetCertificationTypes()

          loader.stopLoader()

          context.$notify({
            title: 'Success',
            message: 'Deleted Successfully',
            type: 'success'
          })

        }, (error) => {

          loader.stopLoader()

          this.$notify({

            title: 'Error',

            message: error.responseJSON.Message,

            type: 'error'

          })
        })
        // context.$message({
        //   type: 'success',
        //   message: 'Delete completed'
        // });
      }).catch(() => {

      })

    },

    cancelpopup: function () {
      this.IsCertificateTypeEdit = false
      $('#AddCertificatemodel').modal('hide')
    },

    editDiscip(data) {
      this.IsDiscEdit = true
      this.DisciplineForm['Id'] = data.row.Id

      this.DisciplineForm = data.row

      $('#AddEventsmodel').modal('show')
    },
    addCertificateTopic() {
      this.isaddCertificateTopic = true
    },
    createCertificateTopic() {
      //admin cert - CREATE CERTIFICATE NAME (ADD ?)
      let context = this
      var certificateTopic = {
        Name: this.CertificateTopicName,
        IsActive: true,
        OrganizationId: this.Certificateparams.organizationid
      }
      loader.startLoader()  
      
      //FG - FOOF - WHILE WRITING SECURITY CODE I FOUND THAT WHEN AN EXCEPTION IS RETURNED FROM THE
      //SERVER THE NOTIFY CODE WAS NOT BEING EXECUTED.
      //I FOUND THAT THE ORIGINAL CODE HAD THE ", (error) => {...}" IN THE WRONG PLACE.
      //IT'S PROPER PLACE IS JUST AFTER THE then's function
      //
      services.AddCertificateName(certificateTopic).then(
        //function (response) {
        (response) => {    //SUCCESS  
          
          //Is this restricted ? -- FG - After Cert - First Release Security
          if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) { 
            loader.stopLoader()
            return;
          }

          context.getAllAgencyCertificates()
          context.isaddCertificateTopic = false
          loader.stopLoader()
          context.$notify({
            title: 'Success',
            message: "Certificate Created",
            type: 'success'
          })        
        }, //END OF THE FUNCTION THAT I THE FIRST PARAMETER OF then
        (error) => {      //FAILURE         
          loader.stopLoader()
          context.$notify({
            title: 'Error',
            message: error.responseJSON.Message,
            type: 'error'
          })//END OF NOTIFY
        } //END OF ERROR FUNCTION
      )//END OF THEN PARARMETERS
    },
    //FG - FOOF - AFTER CERT - FIRST RELEASE - I CANNOT FIND WHERE THE FUNCTION BELOW IS CALLED IS CALLED
    EditCertificateType: function (data) {
      //admin cert - ?? USED ?? EDIT CERT TYPE
      let context = this
      var ID = this.CertificateTypeEditID
      if (ID !== 0) {
        if (context.AddCertificateForm.ExpiryPeriodStatus == 'y') {
          context.cdays = context.AddCertificateForm.ExpiryPeriod * 365
        } else if (context.AddCertificateForm.ExpiryPeriodStatus == 'm') {
          context.cdays = context.AddCertificateForm.ExpiryPeriod * 30
        } else {
          context.cdays = context.AddCertificateForm.ExpiryPeriod
        }

        let model = {
          Id: ID,
          Name: context.AddCertificateForm.Name,
          Description: context.AddCertificateForm.Description,
          IsActive: context.AddCertificateForm.IsActive,
          IssuedBy: context.AddCertificateForm.IssuedBy,
          ExpiryPeriod: context.cdays,
          ExpiryPeriodStatus: context.AddCertificateForm.ExpiryPeriodStatus
        }
        loader.startLoader()
        service.UpdateCertificationType(model).then(function (response) 
        {

          //Is this restricted ? -- FG - After Cert - First Release Security
          if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) { 
            loader.stopLoader()
            return;
          }

          context.IsCertificateTypeEdit = false
          $('#AddCertificatemodel').modal('hide')
          context.CertificateTypeEditID = 0

          context.$notify({
            title: 'Success',
            message: 'Updated certificate type succesfully',
            type: 'success'
          })
          context.GetCertificationTypes()
          loader.stopLoader()

        }, (error) => {

          loader.stopLoader()

          this.$notify({

            title: 'Error',

            message: error.responseJSON.Message,

            type: 'error'

          })
        })

      }


    },

    editcol: function (data) {

      var ID = data.row.Id

      let context = this
      this.modalTitle = 'Edit Certificate Type'
      context.CertificateTypeEditID = ID
      context.AddCertificateForm = deepcopy(data.row)
      if (context.AddCertificateForm.ExpiryPeriodStatus == 'y') {
        context.AddCertificateForm.ExpiryPeriod = context.AddCertificateForm.ExpiryPeriod / 365
      } else if (context.AddCertificateForm.ExpiryPeriodStatus == 'm') {
        context.AddCertificateForm.ExpiryPeriod = context.AddCertificateForm.ExpiryPeriod / 30
      } else {
        context.AddCertificateForm.ExpiryPeriod = context.AddCertificateForm.ExpiryPeriod
      }
      context.IsCertificateTypeEdit = true
      $('#AddCertificatemodel').modal('show')
    },
    selectlocationCell(row) {
      if (this.selectedlocationId != row.LocationId) {
        this.getPools(row.LocationId)
        this.editLocation = false
        this.locationFlag = false
      }

      if (this.selectedlocationId == row.LocationId) {
        this.locationFlag = true

      }
      if (!this.locationFlag) {

        this.currentLocationName = row.LocationName
        this.Timezoneselected = row.LocationOffset
      }

      this.selectedlocationId = row.LocationId

    },

    selectpoolCell(row) {

      if (this.selectedpoolId != row.PoolId) {
        this.editPool = false
      }
      this.currentPoolName = row.PoolName
      this.selectedpoolId = row.PoolId

    },
    enableEditCertificateName(item) {
      item.iseditCertificateName = true
      item.EditCertificatename = item.CertificateName
    },
    cancelEditCertificateName(item) {
      item.iseditCertificateName = false
      item.EditCertificatename = ""
    },
    UpdateCertificateName(item) {
      //admin cert - Update Certificate Name
      let context = this
      var Object = {
        Id: item.CertificateNameId,
        Name: item.EditCertificatename,
        OrganizationId: this.Certificateparams.organizationid
      }

      loader.startLoader()
      services.EditCertificateTopic(Object).then(function (response) {

        //Is this restricted ? -- FG - After Cert - First Release Security
        if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) { 
          loader.stopLoader()
          return;
        }

        item.CertificateName = item.EditCertificatename
        item.iseditCertificateName = false
        loader.stopLoader()
        context.$notify({
          title: 'Success',
          message: 'Certificate Name Updated',
          type: 'success'
        })
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'

        })
      })
    },
    selectpositionCell(row) {

      //this.currentPositionName = row.PositionName
      // this.selectedpoolId = row.PositionId

    },
    togglechildnodes(id) {
      let context = this
      //FG - FOOF - After Cert - First Release Security
      //whether expanding or contracting set isediting to false. 
      //it will be set to true when the edit button is clicked after expanding.
      this.isediting = false; 
      // elem.next('.row').toggle()
      this.AgencyCertificateList.filter(function (item) {       
        if (item.CertificateNameId == id) {
          item.showChild = !item.showChild
          item.isaddChild = false
        }
      })
    },
    addLocation() {
      let context = this
      loader.startLoader()
      let model = {
        LocationName: this.locationName,
        LocationOffset: this.Timezone
      }
      service.AddLocation(model).then(function (response) {
        context.$router.app.$emit('invokePoolLoc')

        if (!context.locations) {
          context.locations = []
        } else {

          context.locations.push({
            LocationId: response.LocationId,
            LocationName: context.locationName,
            LocationOffset: context.Timezone
          })
          context.locationName = ''
          context.Timezone = ''
        }

        loader.stopLoader()

      }, (error) => {

        loader.stopLoader()

        this.$notify({

          title: 'Error',

          message: error.responseJSON.Message,

          type: 'error'

        })
      })

    },
    viewadd(id) {
      this.isediting = false

      // elem.next('.row').toggle()
      this.AgencyCertificateList.filter(function (item) {
        if (item.CertificateNameId == id) {
          item.isaddChild = true
          item.showChild = true
        }
      })
    },
    UpdateLocation(locationid, locationname, Timezone) {
      let context = this

      loader.startLoader()
      service.UpdateLocation({
        LocationId: locationid,
        LocationName: locationname,
        LocationOffset: Timezone
      }).then(function (response) {
        context.editLocation = false
        context.$router.app.$emit('invokePoolLoc')
        for (var i = 0; i < context.locations.length; i++) {

          if (context.locations[i].LocationId == locationid) {
            context.locations[i].LocationName = locationname
            context.locations[i].LocationOffset = Timezone
            context.currentLocationName = locationname,
              context.LocationOffset = Timezone
          }
        }

        loader.stopLoader()

      }, (error) => {

        loader.stopLoader()
        context.currentLocationName = locationname
        this.$notify({

          title: 'Error',

          message: error.responseJSON.Message,

          type: 'error'

        })
      })

    },

    handleCurrentChange(item) {

    },

  },
  watch: {
    selectedagency: function (val) {
      this.isNewCertificates = val == 0 ? false : true
      if (this.isNewCertificates == true)
        this.Certificate.CertificateName = ""
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/Certificates/managecertificates.controller.js